const CUSTOM_TRUEMED_ID = process.env.STRIPE_CUSTOM_TRUEMED_ID ?? '';
const CUSTOM_ACIMA_ID = process.env.STRIPE_CUSTOM_ACIMA_ID ?? '';
const CUSTOM_AFFIRM_ID = process.env.STRIPE_CUSTOM_AFFIRM_ID ?? '';
const CUSTOM_CHARGEAFTER_ID = process.env.STRIPE_CUSTOM_CHARGEAFTER_ID ?? '';
const CUSTOM_SHOP_PAY_ID = process.env.STRIPE_CUSTOM_SHOP_PAY_ID ?? '';

export {
  CUSTOM_TRUEMED_ID,
  CUSTOM_ACIMA_ID,
  CUSTOM_AFFIRM_ID,
  CUSTOM_CHARGEAFTER_ID,
  CUSTOM_SHOP_PAY_ID
};